
export enum ConversationRoomTypeEnum {
    AudioCall   = 1,
    VideoCall  = 2,
}